import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom'; // Ensure Link is imported
import logo from '../assets/logo.png'; // Assuming logo.png is used in this page as well
import logo2 from '../assets/logo2.png';
import './CSS/Login.css'; // Reuse the Login.css file for styling

class ShowTokens2 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      token: null,
      headerAndPayload: '',
      copySuccess: ''
    };
  }

  componentDidMount() {
    const { location } = this.props;
    const token = location.state?.token; // Safely accessing token from location.state

    if (token) {
      const [header, payload] = token.split('.'); // Split token into header and payload
      this.setState({
        token,
        headerAndPayload: `${header}.${payload}`, // Combine header and payload without the signature
      });
    }
  }

  copyToClipboard = () => {
    const textarea = document.querySelector('#tokenTextarea');
    textarea.select();
    document.execCommand('copy');
    this.setState({ copySuccess: 'Copied!' });
  }

  handleRefresh = () => {
    // Refresh the page
    window.location.reload();
  };

  render() {
    const { headerAndPayload, copySuccess } = this.state;

    return (
      <div className="token-container d-flex align-items-center justify-content-center">
        <div className="text-center">
          <img className='logo' src={logo} alt="Logo" />
          <br />
          <h2>Your Generated Token is...:</h2>
          <div className="row justify-content-center">
            <div className="col-sm-8">
              <div className="card">
                <div className="card-body">
                  {headerAndPayload ? (
                    <>
                      <div className="token-slot">
                        <h4>Header and Payload:</h4>
                        <textarea
                          id="tokenTextarea"
                          rows="5"
                          cols="50"
                          className="form-control"
                          value={headerAndPayload} // Display header and payload combined, without the signature
                          readOnly
                        />
                      </div>
                      <button
                        onClick={this.copyToClipboard}
                        className="btn btn-dark mt-3"
                      >
                        Copy Token
                      </button>
                      {copySuccess && <div className="alert alert-success mt-3">{copySuccess}</div>}
                    </>
                  ) : (
                    <p>No token available. Please log in.</p>
                  )}
                  <div className="text-center mt-3">
                    <br />
                    <div><Link to='/conduct-transaction'>Want to store your token on our blockchain?</Link></div> {/* Ensure Link works */}
                    <br />
                    <hr />
                    <button className="btn btn-light btn-lg" onClick={this.handleRefresh}>Logout</button>
                    <br />
                    <div>Powered by</div>
                    <img className='logo2' src={logo2} alt="Logo 2" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(ShowTokens2);
